<template>
  <div v-if="loaded" class="local-table">
    <v-col
      v-if="reportMetadata['showSearch'] == true"
      class="pb-0 pt-0"
      :offset="bPoint.lgAndUp ? 9 : 0"
      :cols="bPoint.lgAndUp ? 3 : 12"
    >
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="searchPlaceholder"
        hide-details
        outlined
        dense
        class="mb-3"
      ></v-text-field>
    </v-col>
    <v-data-table
      dense
      ref="reportTable"
      :footer-props="{ disablePagination : true, disableItemsPerPage : true,showCurrentPage:false,showFirstFastPage:false }"
      :disable-pagination="true"
      hide-default-footer
      :headers="headersFiltered"
      class="stripped font-weight-light"
      :page.sync="page"
      :items="reportData"
      :fixed-header="true"
      multi-sort
      width="100%"
      height="70vh"
      :search="search"
      :custom-sort="customSort"
    >
      <template
        v-for="column in boolColumns"
        v-slot:[`item.${column}`]="{ item }"
      >
          <v-icon :key="column" v-if="item[column] == true"> mdi-check</v-icon>
          <v-icon :key="column" v-if="item[column] == false"> mdi-close</v-icon>
      </template>
       <template v-slot:item.link="{ item }">
        <a :href="item.link" target="_blank">{{ $t("Location") }}</a>
    </template>
     <template v-slot:item.modeUpdate="{ item }">
      <v-btn x-small color="primary" @click="updateDrivingMode(item)">Promeni u {{ item.mode == "Privatna"? "Službenu" : "Privatnu"}}</v-btn>
    </template>
    </v-data-table>
<v-row class="pl-8 pt-2" v-if="!excludeDownload">
    <v-btn color="success" small @click="exportAsCsv" class="mr-2 font-weight-light">CSV</v-btn>
    <v-btn color="success" small @click="exportAsExcel" class="mr-2 font-weight-light">Excel</v-btn>
    <v-btn color="success" small @click="exportAsPdf" class="mr-2 font-weight-light">PDF</v-btn>
</v-row>
<v-dialog
      v-model="commentDialog"
      width="500"
    color="primary">
      <v-card >
        <v-card-title class="text-h5 grey lighten-2" color="primary">
          {{$t("comment")}}
        </v-card-title>

        <v-card-text>
        <br>
          <v-textarea placeholder="Upišite razlog za promenu moda vožnje" outlined v-model="comment"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            
            @click="commentDialog = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            
            @click="performDrivingModeUpdate"
          >
            {{ $t("submit") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <div v-else style="height:200px">
    <p
      class="font-weight-light text-h6 text-center mt-15"
    >{{this.getTranslation('Choose report and set filters')}}</p>

    
  </div>

  
</template>

<script>
import dataTableSort from '@/utils/dataTableSort.js'
import Papa from 'papaparse'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import EventBus from '../../event-bus'
import { generateTableHeaders } from '../../utils/genTable/tableHeaderMaker'
import translate from '@/utils/genTable/multilanguageHelper.js'
import formatDate from '@/utils/formatDateHelper.js'
const Excel = require('exceljs')
import pixelWidth from 'string-pixel-width'
import i18n from '@/plugins/i18n'
import store from '@/store/store'
import moment from 'moment'
import formatUtcRangeToLocal from '@/utils/formatViolationTimestampHelper.js'
import DejaVuSansBase64 from '../../assets/fonts/DejaVuSans/DejaVuSansBase64'
import DejaVuSansBoldBase64 from '../../assets/fonts/DejaVuSans/DejaVuSansBoldBase64'
import { deliverFile, stringToUtf8Bytes } from '@/utils/exportDelivery'

export default {
  name: 'ReportResult',
  data() {
    return {
      comment: null,
      commentDialog: false,
      choosenRow: null,
      search: '',
      page: 1,
      reportData: null,
      reportDataForExcel: null,
      reportMetadata: null,
      loaded: false,
      headers: [],
      dateColumns: [
        'loggedAt',
        'dateFrom',
        'dateTo',
        'stoppedAt',
        'startedDrivingAt',
        'dateOccured',
        'startTime',
        'stopTime',
        'timeMaxSpeedOccured',
        'timestamp',
        'recievedAt',
        'dataAquiredAt',
        'fromDate',
        'lastPacketDateTime',
        'toDate',
        'bussinesDriveStart',
        'privateDriveStart',
        'privateDriveStop',
        'bussinesDriveStop',
        'emailSentAt',
        'measuredAt',
        'incidentOccuredAt',
        'packageReceivedAt',
        'poiLeftAt',
        'poiEnteredAt',
        'startAt',
        'endAt',
        'violationTimestamp',
        'startDate',
        'endDate',
        "correctedAt",
        "startTimestamp",
        "endTimestamp",
        "recoveryTimestamp"
      ],
      dateNoTimeColumns: ['date'],
      currentDateColumns: [],
      preparedExcelData: [],
      boolColumns: ['useLvCan', 'isRoaming'],
      footerProps: {
        disablePagination: true
      },
      excludeDownload: false,
      userData: JSON.parse(store.getters['user/jwtData'].UserData)
    }
  },
  mounted() {
    EventBus.$on('REPORT_GENERATED', this.reportHandler)
  },
  beforeDestroy() {
    EventBus.$off('REPORT_GENERATED', this.reportHandler)
  },
  methods: {
    updateDrivingMode(rowToUpdate) {
      this.commentDialog = true
      this.comment = rowToUpdate.comment
      this.choosenRow = rowToUpdate
    },
    performDrivingModeUpdate() {
      this.commentDialog = false
      this.choosenRow.comment = this.comment
      var rowToUpdate = this.choosenRow
      let mode = rowToUpdate.mode == 'Privatna' ? 'Službena' : 'Privatna'
      let dateFormat = i18n.locale == 'en-US' ? 'MM/DD/YYYY, hh:mm:ss AM/PM' : 'DD.MM.YYYY hh:mm:sss'

      this.$formBuilderAxios
        .post('/reports/ModifyPrivateBusinessDrivingMode', {
          driverId: rowToUpdate.driverId,
          startTime: moment(
            rowToUpdate.timestamp,
            dateFormat
          ).toDate(),
          endTime: moment(
            rowToUpdate.stopTime,
            dateFormat
          ).toDate(),
          drivingMode: mode,
          comment: rowToUpdate.comment
        })
        .then(() => {
          store.dispatch(
            'notification/add',
            { type: 'success', message: this.$t('apiSuccessMsg') },
            { root: true }
          )

          rowToUpdate.mode = mode
        })
    },
    getTranslation(value) {
      return translate(value, 'reports.result')
    },
    reportHandler(data) {
      this.page = 1
      this.preparedExcelData = []
      this.search = ''
      if (data.data.length) {
        this.reportData = data.data
        this.reportDataForExcel = JSON.parse(JSON.stringify(data.data))
        this.reportMetadata = data.metadata
        if (data.sorts) {
          dataTableSort.setSorts(data.sorts)
        }
        this.excludeDownload = data.metadata.excludeDownload
        this.buildTable()
      } else {
        this.reportData = []
        this.reportDataForExcel = []
      }
    },
    buildTable() {
      this.headers = generateTableHeaders(this.reportData[0], '', '')

      this.headers.forEach(header => {
        header.text = translate(header.text, 'reportHeaders')
        const translatedTextWidth = pixelWidth(header.text, { size: 15 })
        if (header.width < translatedTextWidth) {
          header.width = translatedTextWidth
        }

        header.width += 40
      })

      this.currentDateColumns = []
      for (let prop in this.reportData[0]) {
        if (
          this.dateColumns.includes(prop) ||
          this.dateNoTimeColumns.includes(prop)
        ) {
          this.currentDateColumns.push(prop)
        }
      }
      this.reportData.forEach(x => {
        for (let dateColumn of this.currentDateColumns) {
          //console.log(this.reportMetadata)
          //To Do - make this more modular, currently this is the only place here time component is not needed for report display
          if (
            this.reportMetadata.report == 'NonWorkingDaysVehicleUsage' ||
            this.dateNoTimeColumns.includes(dateColumn)
          ) {
            this.$set(x, dateColumn, formatDate(x[dateColumn], 'short', true))
          } else if (
            this.reportMetadata.report == "DigitalTachographDriversViolations" &&
            this.dateColumns.includes(dateColumn)  
          ) {
            this.$set(x, dateColumn, formatUtcRangeToLocal(x[dateColumn], 'long'))
          } else if (!x[dateColumn]) {
            this.$set(x, dateColumn, '/')
          } else {
            this.$set(x, dateColumn, formatDate(x[dateColumn], 'long', true))
          }
        }
      })
      if (this.reportMetadata.report === 'bordercross') {
        const countriesMap = (i18n.getLocaleMessage(i18n.locale) || {}).countries
        if (countriesMap) {
          this.reportData.forEach(x => {
            if (x.country && countriesMap[x.country]) {
              this.$set(x, 'country', countriesMap[x.country])
            }
          })
        }
      }
      this.loaded = true
    },
    prepareDataForExport() {
      let preparedData = []
      let tempObject = {}
      this.$refs.reportTable.internalCurrentItems.forEach(x => {
        tempObject = {}
        for (var prop in x) {
          var foundHeader = this.headersFiltered.find(h => {
            return h.value == prop
          })
          if (foundHeader) {
            var translatedProp = foundHeader.text
            tempObject[translatedProp] = x[prop]
          }
        }
        preparedData.push(tempObject)
      })
      return preparedData
    },
    exportAsCsv() {
      let preparedData = this.prepareDataForExport()
      let fileName = `Report-${Math.floor(Date.now() / 1000)}.csv`
      let mime = 'text/csv;charset=utf-8;'

      var csvBody = Papa.unparse(preparedData)

      var bodyBytes = stringToUtf8Bytes(csvBody)

      var bytesWithBom = new Uint8Array(bodyBytes.length + 3)
      bytesWithBom[0] = 0xef
      bytesWithBom[1] = 0xbb
      bytesWithBom[2] = 0xbf
      bytesWithBom.set(bodyBytes, 3)

      deliverFile(bytesWithBom, fileName, mime)
    },
    prepareColumnsForExcel() {
      let columns = []

      let locale = i18n.locale

      let shortFormat = locale == 'en-US' ? 'm/d/yyyy' : 'dd.m.yyyy.'
      let longFormat =
        locale == 'en-US' ? 'm/dd/yyyy, hh:mm:ss AM/PM' : 'dd.m.yyyy. hh:mm:ss'

      this.headersFiltered.forEach(header => {
        let column = {
          name: header.value,
          key: header.value
        }

        if (this.currentDateColumns.includes(column.key)) {
          if (
            this.reportMetadata.report == 'NonWorkingDaysVehicleUsage' ||
            this.dateNoTimeColumns.includes(column.key)
          ) {
            column['width'] = 15
            column['style'] = { numFmt: shortFormat }
          } else {
            column['width'] = 30
            column['style'] = { numFmt: longFormat }
          }
        }

        columns.push(column)
      })

      return columns
    },
    prepareHeadersForExcel() {
      let headers = {}

      this.headersFiltered
        .filter(x => x.value != 'modeUpdate')
        .forEach(header => {
          headers[header.value] = header.text
        })

      return headers
    },
    prepareDataForExcel() {
      if (this.preparedExcelData.length) {
        return this.preparedExcelData
      }

      this.reportDataForExcel.forEach(x => {
        let keys = Object.keys(x)
        let tempArray = []
        for (let key of keys) {
          if (x[key] == null) {
            x[key] = ''
          } else if (this.reportMetadata.report == "DigitalTachographDriversViolations" && this.currentDateColumns.includes(key)) {
            x[key] = formatUtcRangeToLocal(x[key], 'long')
          } else if (this.currentDateColumns.includes(key)) {
            x[key] = this.toLocalDate(x[key])
          } else if (key == 'link') {
            x[key] = {
              text: translate('Location', 'fields'),
              hyperlink: x[key],
              tooltip: x[key]
            }
          }
          if (
            key == 'modeUpdate' ||
            (this.reportMetadata.excludedColumns &&
              this.reportMetadata.excludedColumns.includes(key))
          ) {
            delete x[key]
            continue
          }
          tempArray.push(x[key])
        }
        this.preparedExcelData.push(Object.values(x))
      })
      return this.preparedExcelData
    },
    filterExcelData(data) {
      let filteredData = []
      this.$refs.reportTable.internalCurrentItems.forEach(x => {
        filteredData.push(data[this.$refs.reportTable.items.indexOf(x)])
      })

      return filteredData
    },
    toLocalDate(date) {
      const localTime = new Date(date)
      const diffHours = localTime.getTimezoneOffset() / -60
      localTime.setHours(localTime.getHours() + diffHours * 2)
      return localTime
    },
    exportAsExcel() {
      const workbook = new Excel.Workbook()
      workbook.creator = 'Puregreen'
      workbook.lastModifiedBy = 'Puregreen'

      const ws = workbook.addWorksheet(this.reportMetadata['report'])

      const columns = this.prepareColumnsForExcel()
      ws.columns = columns

      ws.insertRow(3, this.prepareHeadersForExcel())
      ws.insertRows(4, this.filterExcelData(this.prepareDataForExcel()))

      ws.mergeCells('A1:H1')
      ws.getCell('A1').value = `${
        this.reportMetadata['report']
      } ${this.getTranslation('Report for period since')} ${formatDate(
        this.reportMetadata['startDate']
      )} ${this.getTranslation('until')} ${formatDate(
        this.reportMetadata['endDate']
      )} - ${this.userData.Tenant}`

      const columnsToSkip = columns
        .filter(x => x.width != undefined)
        .map(x => x.key)
      const cellsToSkip = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1']

      ws.columns.forEach(column => {
        var dataMax = 0
        if (!columnsToSkip.includes(column.key)) {
          column.eachCell({ includeEmpty: true }, function(cell) {
            if (!cellsToSkip.includes(cell.address)) {
              var columnLength = cell.value ? cell.value.length : 0
              if (columnLength > dataMax) {
                dataMax = columnLength
              }
            }
          })
          column.width = dataMax < 10 ? 10 : dataMax + 5
        }
      })

      var fileName = 'Report-' + Math.floor(Date.now() / 1000) + '.xlsx';
      var mime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      workbook.xlsx.writeBuffer()
        .then(function (data) {
          deliverFile(data, fileName, mime);
        })
        .catch(function (err) {
          console.error('[excel] writeBuffer failed', err);
        });

    },
    exportAsPdf() {
      var source = this.$refs.reportTable
      let headers = []
      let rows = []
      let pdfName = `Report-${Math.floor(Date.now() / 1000)}`
      var mime = 'application/pdf'

      this.headersFiltered.forEach(header => {
        headers.push({
          content: header.text,
          styles: { minCellWidth: 15, fontSize: 6 }
        })
      })

      source.internalCurrentItems.forEach(element => {
        var temp = []
        this.headersFiltered.forEach(header => {
          temp.push({
            content: element[header.value] == null ? '' : element[header.value],
            styles: { minCellWidth: 15, fontSize: 6 }
          })
        })
        rows.push(temp)
      })
      var doc = new jsPDF('landscape')

      doc.addFileToVFS("DejaVuSans.ttf", DejaVuSansBase64);
      doc.addFont("DejaVuSans.ttf", "DejaVuSans", "normal");

      doc.addFileToVFS("DejaVuSans-Bold.ttf", DejaVuSansBoldBase64);
      doc.addFont("DejaVuSans-Bold.ttf", "DejaVuSans", "bold");

      doc.setFont("DejaVuSans", "normal");

      doc.autoTable({
        head: [headers],
        body: rows,
        startY: 10,

        styles: { font: "DejaVuSans", fontStyle: 'normal', fontSize: 6 },
        headStyles: { font: "DejaVuSans", fontStyle: 'bold', fontSize: 6}
      })

      var arrayBuffer = doc.output('arraybuffer')
      deliverFile(arrayBuffer, pdfName, mime)
    },
  },
  computed: {
    customSort: () => dataTableSort.sort,
    headersFiltered() {
      return this.headers.filter(
        x =>
          x.value != 'formated' &&
          (this.reportMetadata.excludedColumns == null ||
            !this.reportMetadata.excludedColumns.includes(x.value))
      )
    },
    searchPlaceholder() {
      return translate('Search', 'realtimeMap')
    },
    bPoint() {
      return this.$vuetify.breakpoint
    }
  }
}
</script>
